class ConsoleManager {
  /**
   * The above function is a constructor function that creates a new object with a property called
   * consoleConfig. The consoleConfig property is an object that has four properties: log, info,
   * error, and warm. Each of these properties has a string value
   */
  constructor() {
    this.consoleConfig = {
      log: "log",
      info: "info",
      error: "log",
      warm: "warm",
    };
  }
  /**
   * It takes the method name you want to use, looks up the corresponding method name in the
   * consoleConfig object, and then calls the method using the new method name
   */
  info() {
    let methodName = "info";
    let newMethodName = this.consoleConfig[methodName];
    console[newMethodName].apply(null, arguments);
  }
  /**
   * If the method name is in the config object, use the value of the config object as the method
   * name, otherwise use the method name as the method name.
   */
  log() {
    let methodName = "log";
    let newMethodName = this.consoleConfig[methodName];
    console[newMethodName].apply(null, arguments);
  }
  /**
   * It takes the method name passed to it, looks up the corresponding value in the consoleConfig
   * object, and then calls the console method with that name
   */
  error() {
    let methodName = "log";
    let newMethodName = this.consoleConfig[methodName];
    console[newMethodName].apply(null, arguments);
  }
  /**
   * It takes the name of the method you want to call, looks up the name of the method you want to
   * call in the consoleConfig object, and then calls the method you want to call
   */
  warm() {
    let methodName = "warm";
    let newMethodName = this.consoleConfig[methodName];
    console[newMethodName].apply(null, arguments);
  }
}

export default ConsoleManager;
